import * as yup from "yup";
import { MISSION_GOAL } from "utils/constants/options";

const coinFieldSchema = (...goalValues) =>
  yup.string().when("mission_goal", (g) =>
    goalValues.includes(g?.value)
      ? yup.string().required("")
      : yup.string().notRequired()
  );

const createMissionFormSchema = (minTeamCount = 0) => yup.object().shape({
  image_file_th: yup.array().test("has-active-image", "", (value) => {
    return value?.some((item) => !item.isDelete);
  }),
  image_file_en: yup.array().test("has-active-image", "", (value) => {
    return value?.some((item) => !item.isDelete);
  }),
  name_th: yup.string().trim().required(""),
  name_en: yup.string().trim().required(""),
  company_ids: yup
    .array()
    .of(
      yup.object().shape({
        label: yup.string(),
        value: yup.string(),
      })
    )
    .min(1, "")
    .required(""),
  begin_date: yup.date().nullable().required(""),
  end_date: yup.date().nullable().required(""),
  category: yup
    .object()
    .nullable()
    .required("")
    .test("has-value", "", (v) => Boolean(v && v.value)),
  challenge_type: yup
    .object()
    .nullable()
    .required("")
    .test("has-value", "", (v) => Boolean(v && v.value)),
  registration_start_date: yup
    .date()
    .nullable()
    .when("challenge_type", (fmt, schema) =>
      fmt?.value === "team" ? schema.required("") : schema.notRequired()
    ),
  register_end_date: yup
    .date()
    .nullable()
    .when("challenge_type", (fmt, schema) =>
      fmt?.value === "team" ? schema.required("") : schema.notRequired()
    ),
  team_count: yup.string().when("challenge_type", (fmt) => {
    if (fmt?.value !== "team") return yup.string().notRequired();
    return yup.string().required("").test(
      "min-team-count",
      `กรุณาระบุจำนวนทีมให้เท่ากับหรือมากกว่า ${minTeamCount}`,
      (val) => !minTeamCount || Number(val) >= minTeamCount
    );
  }),
  team_size: yup.string().when("challenge_type", (fmt) =>
    fmt?.value === "team" ? yup.string().required("") : yup.string().notRequired()
  ),
  mission_goal: yup
    .object()
    .nullable()
    .required("")
    .test("has-value", "", (v) => Boolean(v && v.value)),
  target_amount: yup.string().when("mission_goal", (g) =>
    g?.value === MISSION_GOAL.HIGHEST_SCORE.value
      ? yup.string().notRequired()
      : yup.string().required("")
  ),
  success_coin_amount: coinFieldSchema(
    MISSION_GOAL.SHARED_GOAL.value,
    MISSION_GOAL.FIRST_COMPLETE.value
  ),
  fail_coin_amount: coinFieldSchema(
    MISSION_GOAL.SHARED_GOAL.value,
    MISSION_GOAL.FIRST_COMPLETE.value
  ),
  reward_1st_amount: coinFieldSchema(MISSION_GOAL.HIGHEST_SCORE.value),
  reward_2nd_amount: coinFieldSchema(MISSION_GOAL.HIGHEST_SCORE.value),
  reward_3rd_amount: coinFieldSchema(MISSION_GOAL.HIGHEST_SCORE.value),
  reward_consolation_amount: coinFieldSchema(MISSION_GOAL.HIGHEST_SCORE.value),
});

export default createMissionFormSchema;
